import React, { createContext, useContext, useMemo } from 'react'

const ConfigContext = createContext(null)

export const ConfigProvider = ({ children }) => {
  const config = useMemo(() => {
    const isProd = (window.location.hostname !== 'localhost' && window.location.hostname !== '192.168.100.19' ) && 
      window.location.hostname !== '127.0.0.1'
      
    let apiBaseUrl
    
    if (isProd) {
      const protocol = window.location.protocol
      const host = window.location.host
      apiBaseUrl = `${protocol}//${host}`
    } else {
      apiBaseUrl = window.location.hostname === 'localhost' ? 'http://localhost:5555' : 'http://192.168.100.19:5555'
    }

    apiBaseUrl = 'https://vps.reciation.org'
    
    return {
      isProd,
      apiBaseUrl,
      
      getApiUrl(endpoint) {
        if (!endpoint.startsWith('/')) {
          endpoint = '/' + endpoint
        }
        return `${apiBaseUrl}${endpoint}`
      },

      async fetchWelcomeMessage() {
        const response = await fetch(this.getApiUrl(`/api/welcome-message`))
        const data = await response.json()
        return data
      },
      
      async getCoinTracks(rsid) {
        const response = await fetch(this.getApiUrl(`/api/coin_tracks/${rsid}`))
        const data = await response.json()
        return data
      },
      
      async getCoinByCode(code) {
        const response = await fetch(this.getApiUrl(`/api/token/${code}`))
        const data = await response.json()
        return data
      },
      
      async getCoinById(coinid) {
        const response = await fetch(this.getApiUrl(`/api/token/id/${coinid}`))
        const data = await response.json()
        return data
      },
      
      async addCoinLocation(locationData) {
        try {
          const response = await fetch(this.getApiUrl('/api/location'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(locationData)
          })
          const data = await response.json()
          
          if (response.status === 429) {
            return {
              success: false,
              message: data.message,
              cooldown: data.cooldown
            }
          }
          
          return data
        } catch (error) {
          return {
            success: false,
            message: error.message || 'Error adding location'
          }
        }
        return data
      }
    }
  }, [])
  
  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  )
}

export const useConfig = () => {
  const config = useContext(ConfigContext)
  
  if (!config) {
    throw new Error('useConfig must be used within a ConfigProvider')
  }
  
  return config
}

export default ConfigContext
